import { useEffect, useState } from "react"
import { Explosion } from "./Explosion"

// audios
import airplane from "../../../assets/audio/airplane.mp3"
var audio = new Audio(airplane)

const updates = 50

// finaliza el viaje; me borro
export const flyTime = parseInt(
  getComputedStyle(document.documentElement).getPropertyValue(
    "--bomber-duration"
  )
)

export const Bomber = ({ bombard, done, doneNuking }) => {
  const s3 = {
    top: `calc(${bombard.y} * 100% / var(--grid-size))`,
    left: `calc(${bombard.x} * 100% / var(--grid-size))`,
  }

  const [exploding, setExploding] = useState(false)

  useEffect(() => {
    const halfway = (flyTime * 1000) / 2,
      gif_duration = 1700 / 2,
      timeoutExplosion = setTimeout(() => {
        setExploding(true)
        doneNuking(bombard)
      }, halfway),
      timeoutExplosionFadeOut = setTimeout(
        () => setExploding(false),
        halfway + gif_duration
      ),
      timeoutDone = setTimeout(() => done(bombard), flyTime * 1000)

    audio.currentTime = 0
    audio.volume = 1
    audio.play()

    // opcional:
    // airplan volume sound-effect
    var c = 0,
      i = setInterval(
        () => {
          const p = (c + 1) / updates,
            vol = p < 0.5 ? Math.tanh(p * 2) : Math.tanh(Math.abs(p - 1) * 3)

          audio.volume = vol
          c++
        },
        (flyTime * 1000) / updates
      )

    // stopper
    const t = setTimeout(
      () => clearInterval(i),
      flyTime * 1000 * (1 + 1 / updates)
    )

    return () => {
      clearTimeout(timeoutExplosion)
      clearTimeout(timeoutExplosionFadeOut)
      clearTimeout(timeoutDone)
      // audio
      clearTimeout(t)
      clearInterval(i)
      audio.pause()
      audio.currentTime = 0
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <div className="bomber" style={s3}></div>
      {exploding && <Explosion pos={bombard} />}
    </>
  )
}
